import React from 'react'

function LoginButton() {
    return (
        <a className="nav-link magictime tinRightIn LOGINOUT" href="/login">LOGIN</a>
    )
}

export default LoginButton